import React from "react";
import { motion } from "framer-motion";

const HeroImage = ({ 
  image, 
  alt, 
  width = "md:w-3/5", 
  maxWidth = "max-w-[2500px]",
  className = "" 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.3 }}
      className={`w-full ${width} h-auto mt-8 md:mt-0 flex justify-end items-center ${className}`}
    >
      <img 
        src={image} 
        alt={alt}
        className={`w-full ${maxWidth} h-auto ${className}`}
      />
    </motion.div>
  );
};

export default HeroImage; 